import Vue from 'vue'
import Vuex from 'vuex'
import projects from './modules/projects'
import app from './modules/app'


import notifications from './modules/notifications'

import contests from './modules/contests'
import profile_view from './modules/profile_view'

import user_projects from './modules/user_projects'

//New
import account from './modules/account'
import wallet from './modules/wallet'
import profile from './modules/profile'
import admin from './modules/admin'


Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    loading: false
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async load(context) {
      context.state.loading = true
      await Promise.all([context.dispatch('app/load'), context.dispatch('account/init')])
      context.state.loading = false
    }
  },
  modules: {
    projects,
    app,
    notifications,
    contests,
    profile_view,
    user_projects,
    account,
    wallet,
    profile,
    admin
  }
})
